import { RequestStatus, TrackingLevel, defaults, entities, getAPIMethod } from 'typed/api';
import { ExtractAction, NetworkAction, action, entityActionSet, networkAction } from './utils';
import { assertNever } from 'typed/utils';

export const
    trackingLevels = {
        ...entityActionSet(defaults.TrackingLevel, {
            loadAll: networkAction('LOAD_ALL_TRACKING_LEVELS', getAPIMethod('TrackingLevelApi', 'loadAll'))
        }),
        edit: (level: entities.TrackingLevel, sync = false): NetworkAction<'EDIT_TRACKING_LEVEL', any, any> =>
            async(dispatch) => {
                dispatch(action('EDIT_TRACKING_LEVEL', { entityID: level.ID, entity: level, status: RequestStatus.UNSYNCED }));

                if (sync) {
                    await dispatch(networkAction('EDIT_TRACKING_LEVEL', { entityID: level.ID, entity: level }, getAPIMethod('TrackingLevelApi', 'edit'), level, level.ID));
                }
            }
    },

    { loadAll: loadAllCompanyLegalEntityTypes } = entityActionSet({} as entities.Entity, { loadAll: networkAction('LOAD_ALL_COMPANY_LEGAL_ENTITY_TYPES', getAPIMethod('CompanyLegalEntityTypeApi', 'loadAll')) }),

    { loadAll: loadAllCorporateStructureSortModes } = entityActionSet({} as entities.Entity, { loadAll: networkAction('LOAD_ALL_CORPORATE_STRUCTURE_SORT_MODES', getAPIMethod('CorporateStructureSortModeApi', 'loadAll')) }),

    products = {
        ...entityActionSet(defaults.Product, {
            loadAll: networkAction('LOAD_ALL_PRODUCTS', getAPIMethod('ProductApi', 'loadAll')),
            load: networkAction('LOAD_PRODUCT', getAPIMethod('ProductApi', 'load')),
            add: networkAction('ADD_PRODUCT', getAPIMethod('ProductApi', 'add')),
            editAll: networkAction('EDIT_ALL_PRODUCTS', getAPIMethod('ProductApi', 'editAll')),
            edit: networkAction('EDIT_PRODUCT', getAPIMethod('ProductApi', 'edit')),
            delete: networkAction('DELETE_PRODUCT', getAPIMethod('ProductApi', 'delete'))
        }),
        findOrCreateDefault: () => networkAction('FIND_OR_CREATE_DEFAULT_PRODUCT', getAPIMethod('ProductApi', 'findOrCreateDefault'))
    },

    geoAreas = {
        ...entityActionSet(defaults.GeoArea, {
            loadAll: networkAction('LOAD_ALL_GEO_AREAS', getAPIMethod('GeoAreaApi', 'loadAll')),
            load: networkAction('LOAD_GEO_AREA', getAPIMethod('GeoAreaApi', 'load')),
            add: networkAction('ADD_GEO_AREA', getAPIMethod('GeoAreaApi', 'add')),
            editAll: networkAction('EDIT_ALL_GEO_AREAS', getAPIMethod('GeoAreaApi', 'editAll')),
            edit: networkAction('EDIT_GEO_AREA', getAPIMethod('GeoAreaApi', 'edit')),
            delete: networkAction('DELETE_GEO_AREA', getAPIMethod('GeoAreaApi', 'delete'))
        }),
        findOrCreateDefault: () => networkAction('FIND_OR_CREATE_DEFAULT_GEO_AREA', getAPIMethod('GeoAreaApi', 'findOrCreateDefault'))
    },

    customers = {
        ...entityActionSet(defaults.Customer, {
            loadAll: networkAction('LOAD_ALL_CUSTOMERS', getAPIMethod('CustomerApi', 'loadAll')),
            load: networkAction('LOAD_CUSTOMER', getAPIMethod('CustomerApi', 'load')),
            add: networkAction('ADD_CUSTOMER', getAPIMethod('CustomerApi', 'add')),
            editAll: networkAction('EDIT_ALL_CUSTOMERS', getAPIMethod('CustomerApi', 'editAll')),
            edit: networkAction('EDIT_CUSTOMER', getAPIMethod('CustomerApi', 'edit')),
            delete: networkAction('DELETE_CUSTOMER', getAPIMethod('CustomerApi', 'delete'))
        }),
        findOrCreateDefault: () => networkAction('FIND_OR_CREATE_DEFAULT_CUSTOMER', getAPIMethod('CustomerApi', 'findOrCreateDefault'))
    },

    trackingLevel1Items = {
        ...entityActionSet(defaults.TrackingLevel1Item, {
            loadAll: networkAction('LOAD_ALL_TRACKING_LEVEL_1_ITEMS', getAPIMethod('TrackingLevel1ItemApi', 'loadAll')),
            load: networkAction('LOAD_TRACKING_LEVEL_1_ITEM', getAPIMethod('TrackingLevel1ItemApi', 'load')),
            add: networkAction('ADD_TRACKING_LEVEL_1_ITEM', getAPIMethod('TrackingLevel1ItemApi', 'add')),
            editAll: networkAction('EDIT_ALL_TRACKING_LEVEL_1_ITEMS', getAPIMethod('TrackingLevel1ItemApi', 'editAll')),
            edit: networkAction('EDIT_TRACKING_LEVEL_1_ITEM', getAPIMethod('TrackingLevel1ItemApi', 'edit')),
            delete: networkAction('DELETE_TRACKING_LEVEL_1_ITEM', getAPIMethod('TrackingLevel1ItemApi', 'delete'))
        }),
        findOrCreateDefault: () => networkAction('FIND_OR_CREATE_DEFAULT_TRACKING_LEVEL_1_ITEM', getAPIMethod('TrackingLevel1ItemApi', 'findOrCreateDefault'))
    },

    trackingLevel2Items = {
        ...entityActionSet(defaults.TrackingLevel2Item, {
            loadAll: networkAction('LOAD_ALL_TRACKING_LEVEL_2_ITEMS', getAPIMethod('TrackingLevel2ItemApi', 'loadAll')),
            load: networkAction('LOAD_TRACKING_LEVEL_2_ITEM', getAPIMethod('TrackingLevel2ItemApi', 'load')),
            add: networkAction('ADD_TRACKING_LEVEL_2_ITEM', getAPIMethod('TrackingLevel2ItemApi', 'add')),
            editAll: networkAction('EDIT_ALL_TRACKING_LEVEL_2_ITEMS', getAPIMethod('TrackingLevel2ItemApi', 'editAll')),
            edit: networkAction('EDIT_TRACKING_LEVEL_2_ITEM', getAPIMethod('TrackingLevel2ItemApi', 'edit')),
            delete: networkAction('DELETE_TRACKING_LEVEL_2_ITEM', getAPIMethod('TrackingLevel2ItemApi', 'delete'))
        }),
        findOrCreateDefault: () => networkAction('FIND_OR_CREATE_DEFAULT_TRACKING_LEVEL_2_ITEM', getAPIMethod('TrackingLevel2ItemApi', 'findOrCreateDefault'))
    },

    trackingLevel3Items = {
        ...entityActionSet(defaults.TrackingLevel3Item, {
            loadAll: networkAction('LOAD_ALL_TRACKING_LEVEL_3_ITEMS', getAPIMethod('TrackingLevel3ItemApi', 'loadAll')),
            load: networkAction('LOAD_TRACKING_LEVEL_3_ITEM', getAPIMethod('TrackingLevel3ItemApi', 'load')),
            add: networkAction('ADD_TRACKING_LEVEL_3_ITEM', getAPIMethod('TrackingLevel3ItemApi', 'add')),
            editAll: networkAction('EDIT_ALL_TRACKING_LEVEL_3_ITEMS', getAPIMethod('TrackingLevel3ItemApi', 'editAll')),
            edit: networkAction('EDIT_TRACKING_LEVEL_3_ITEM', getAPIMethod('TrackingLevel3ItemApi', 'edit')),
            delete: networkAction('DELETE_TRACKING_LEVEL_3_ITEM', getAPIMethod('TrackingLevel3ItemApi', 'delete'))
        }),
        findOrCreateDefault: () => networkAction('FIND_OR_CREATE_DEFAULT_TRACKING_LEVEL_3_ITEM', getAPIMethod('TrackingLevel3ItemApi', 'findOrCreateDefault'))
    },

    trackingLevel4Items = {
        ...entityActionSet(defaults.TrackingLevel4Item, {
            loadAll: networkAction('LOAD_ALL_TRACKING_LEVEL_4_ITEMS', getAPIMethod('TrackingLevel4ItemApi', 'loadAll')),
            load: networkAction('LOAD_TRACKING_LEVEL_4_ITEM', getAPIMethod('TrackingLevel4ItemApi', 'load')),
            add: networkAction('ADD_TRACKING_LEVEL_4_ITEM', getAPIMethod('TrackingLevel4ItemApi', 'add')),
            editAll: networkAction('EDIT_ALL_TRACKING_LEVEL_4_ITEMS', getAPIMethod('TrackingLevel4ItemApi', 'editAll')),
            edit: networkAction('EDIT_TRACKING_LEVEL_4_ITEM', getAPIMethod('TrackingLevel4ItemApi', 'edit')),
            delete: networkAction('DELETE_TRACKING_LEVEL_4_ITEM', getAPIMethod('TrackingLevel4ItemApi', 'delete'))
        }),
        findOrCreateDefault: () => networkAction('FIND_OR_CREATE_DEFAULT_TRACKING_LEVEL_4_ITEM', getAPIMethod('TrackingLevel4ItemApi', 'findOrCreateDefault'))
    },

    companyLegalEntities = {
        ...entityActionSet(defaults.CompanyLegalEntity, {
            loadAll: networkAction('LOAD_ALL_COMPANY_LEGAL_ENTITIES', getAPIMethod('CompanyLegalEntityApi', 'loadAll')),
            load: networkAction('LOAD_COMPANY_LEGAL_ENTITY', getAPIMethod('CompanyLegalEntityApi', 'load')),
            add: networkAction('ADD_COMPANY_LEGAL_ENTITY', getAPIMethod('CompanyLegalEntityApi', 'add')),
            edit: networkAction('EDIT_COMPANY_LEGAL_ENTITY', getAPIMethod('CompanyLegalEntityApi', 'edit')),
            delete: networkAction('DELETE_COMPANY_LEGAL_ENTITY', getAPIMethod('CompanyLegalEntityApi', 'delete')),
            voidAll: action('VOID_ALL_COMPANY_LEGAL_ENTITIES')
        }),
        findOrCreateDefault: () => networkAction('FIND_OR_CREATE_DEFAULT_COMPANY_LEGAL_ENTITY', getAPIMethod('CompanyLegalEntityApi', 'findOrCreateDefault'))
    },

    companyFunctions = {
        ...entityActionSet(defaults.CompanyFunction, {
            loadAll: networkAction('LOAD_ALL_COMPANY_FUNCTIONS', getAPIMethod('CompanyFunctionApi', 'loadAll')),
            load: networkAction('LOAD_COMPANY_FUNCTION', getAPIMethod('CompanyFunctionApi', 'load')),
            add: networkAction('ADD_COMPANY_FUNCTION', getAPIMethod('CompanyFunctionApi', 'add')),
            edit: networkAction('EDIT_COMPANY_FUNCTION', getAPIMethod('CompanyFunctionApi', 'edit')),
            delete: networkAction('DELETE_COMPANY_FUNCTION', getAPIMethod('CompanyFunctionApi', 'delete')),
            voidAll: action('VOID_ALL_COMPANY_FUNCTIONS')
        }),
        findOrCreateDefault: () => networkAction('FIND_OR_CREATE_DEFAULT_COMPANY_FUNCTION', getAPIMethod('CompanyFunctionApi', 'findOrCreateDefault'))
    },

    setTeamCustomRoadmapRange = (companyFunctionID: number, startDate: Date, endDate: Date) => action('SET_TEAM_CUSTOM_ROADMAP_RANGE', { companyFunctionID, startDate, endDate }),
    setCompanyFunctionCustomJourneyRange = (companyFunctionID: number, startDate: Date | null, endDate: Date | null) => action('SET_COMPANY_FUNCTION_CUSTOM_JOURNEY_RANGE', { entityID: companyFunctionID, startDate, endDate }),

    setUserCustomRoadmapRange = (startDate: Date, endDate: Date) => action('SET_USER_CUSTOM_ROADMAP_RANGE', { startDate, endDate }),

    companyVirtualTeams = entityActionSet(defaults.CompanyVirtualTeam, {
        loadAll: networkAction('LOAD_ALL_COMPANY_VIRTUAL_TEAMS', getAPIMethod('CompanyVirtualTeamApi', 'loadAll')),
        load: networkAction('LOAD_COMPANY_VIRTUAL_TEAM', getAPIMethod('CompanyVirtualTeamApi', 'load')),
        add: networkAction('ADD_COMPANY_VIRTUAL_TEAM', getAPIMethod('CompanyVirtualTeamApi', 'add')),
        edit: networkAction('EDIT_COMPANY_VIRTUAL_TEAM', getAPIMethod('CompanyVirtualTeamApi', 'edit')),
        delete: networkAction('DELETE_COMPANY_VIRTUAL_TEAM', getAPIMethod('CompanyVirtualTeamApi', 'delete')),
        voidAll: action('VOID_ALL_COMPANY_VIRTUAL_TEAMS')
    }),

    setCompanyVirtualTeamCustomJourneyRange = (virtualTeamID: number, startDate: Date | null, endDate: Date | null) => action('SET_COMPANY_VIRTUAL_TEAM_CUSTOM_JOURNEY_RANGE', { entityID: virtualTeamID, startDate, endDate }),

    companyVirtualTeamMembers = entityActionSet(defaults.CompanyVirtualTeamMember, {
        loadAll: networkAction('LOAD_ALL_COMPANY_VIRTUAL_TEAM_MEMBERS', getAPIMethod('CompanyVirtualTeamMemberApi', 'loadAll')),
        load: networkAction('LOAD_COMPANY_VIRTUAL_TEAM_MEMBER', getAPIMethod('CompanyVirtualTeamMemberApi', 'load')),
        add: networkAction('ADD_COMPANY_VIRTUAL_TEAM_MEMBER', getAPIMethod('CompanyVirtualTeamMemberApi', 'add')),
        edit: networkAction('EDIT_COMPANY_VIRTUAL_TEAM_MEMBER', getAPIMethod('CompanyVirtualTeamMemberApi', 'edit')),
        delete: networkAction('DELETE_COMPANY_VIRTUAL_TEAM_MEMBER', getAPIMethod('CompanyVirtualTeamMemberApi', 'delete')),
        voidAll: action('VOID_ALL_COMPANY_VIRTUAL_TEAM_MEMBERS')
    }),

    trackingLevelItems: {
        loadAll(levelID: TrackingLevel): NetworkAction<string, void, entities.NetworkArray<entities.TrackingLevelItemBase>>;
        load(levelID: TrackingLevel, itemID: number): NetworkAction<string, void, entities.TrackingLevelItemBase>;
        add(levelID: TrackingLevel, item: entities.TrackingLevelItemBase): NetworkAction<string, void, void>;
        add(levelID: TrackingLevel, item: entities.TrackingLevelItemBase, sync: boolean): NetworkAction<string, void, number>;
        add(levelID: TrackingLevel, item: entities.TrackingLevelItemBase, sync: boolean, reloadAfterSync: boolean): NetworkAction<string, void, entities.TrackingLevelItemBase>;
        editAll(levelID: TrackingLevel, items: entities.TrackingLevelItemBase[]): NetworkAction<string, void, void>;
        editAll(levelID: TrackingLevel, items: entities.TrackingLevelItemBase[], sync: boolean): NetworkAction<string, void, void>;
        editAll(levelID: TrackingLevel, items: entities.TrackingLevelItemBase[], sync: boolean, reloadAfterSync: boolean): NetworkAction<string, void, entities.TrackingLevelItemBase>;
        edit(levelID: TrackingLevel, item: entities.TrackingLevelItemBase): NetworkAction<string, void, void>;
        edit(levelID: TrackingLevel, item: entities.TrackingLevelItemBase, sync: boolean): NetworkAction<string, void, void>;
        edit(levelID: TrackingLevel, item: entities.TrackingLevelItemBase, sync: boolean, reloadAfterSync: boolean): NetworkAction<string, void, entities.TrackingLevelItemBase>;
        delete(levelID: TrackingLevel, item: entities.TrackingLevelItemBase): NetworkAction<string, void, void>;
        findOrCreateDefault(levelID: TrackingLevel): NetworkAction<string, void, entities.TrackingLevelItemBase>;
    } = {
        loadAll: (levelID) => {
            switch (levelID) {
                case TrackingLevel.PRODUCT: return products.loadAll();
                case TrackingLevel.GEO_AREA: return geoAreas.loadAll();
                case TrackingLevel.CUSTOMER: return customers.loadAll();
                case TrackingLevel.TRACKING_LEVEL_1: return trackingLevel1Items.loadAll();
                case TrackingLevel.TRACKING_LEVEL_2: return trackingLevel2Items.loadAll();
                case TrackingLevel.TRACKING_LEVEL_3: return trackingLevel3Items.loadAll();
                case TrackingLevel.TRACKING_LEVEL_4: return trackingLevel4Items.loadAll();
                case TrackingLevel.COMPANY_LEGAL_ENTITY: return companyLegalEntities.loadAll();
                case TrackingLevel.COMPANY_FUNCTION: return companyFunctions.loadAll();
                default: return assertNever(levelID, `Unknown tracking level ${levelID}.`);
            }
        },

        load: (levelID, itemID) => {
            switch (levelID) {
                case TrackingLevel.PRODUCT: return products.load(itemID);
                case TrackingLevel.GEO_AREA: return geoAreas.load(itemID);
                case TrackingLevel.CUSTOMER: return customers.load(itemID);
                case TrackingLevel.TRACKING_LEVEL_1: return trackingLevel1Items.load(itemID);
                case TrackingLevel.TRACKING_LEVEL_2: return trackingLevel2Items.load(itemID);
                case TrackingLevel.TRACKING_LEVEL_3: return trackingLevel3Items.load(itemID);
                case TrackingLevel.TRACKING_LEVEL_4: return trackingLevel4Items.load(itemID);
                case TrackingLevel.COMPANY_LEGAL_ENTITY: return companyLegalEntities.load(itemID);
                case TrackingLevel.COMPANY_FUNCTION: return companyFunctions.load(itemID);
                default: return assertNever(levelID, `Unknown tracking level ${levelID}.`);
            }
        },

        add: (levelID: TrackingLevel, item: entities.TrackingLevelItemBase, sync = false): any => {
            switch (levelID) {
                case TrackingLevel.PRODUCT: return sync ? products.add(item, true) : products.add(item);
                case TrackingLevel.GEO_AREA: return sync ? geoAreas.add(item, true) : geoAreas.add(item);
                case TrackingLevel.CUSTOMER: return sync ? customers.add(item, true) : customers.add(item);
                case TrackingLevel.TRACKING_LEVEL_1: return sync ? trackingLevel1Items.add(item, true) : trackingLevel1Items.add(item);
                case TrackingLevel.TRACKING_LEVEL_2: return sync ? trackingLevel2Items.add(item, true) : trackingLevel2Items.add(item);
                case TrackingLevel.TRACKING_LEVEL_3: return sync ? trackingLevel3Items.add(item, true) : trackingLevel3Items.add(item);
                case TrackingLevel.TRACKING_LEVEL_4: return sync ? trackingLevel4Items.add(item, true) : trackingLevel4Items.add(item);
                case TrackingLevel.COMPANY_LEGAL_ENTITY: return sync ? companyLegalEntities.add(item as entities.CompanyLegalEntity, true) : companyLegalEntities.add(item as entities.CompanyLegalEntity);
                case TrackingLevel.COMPANY_FUNCTION: return sync ? companyFunctions.add(item as entities.CompanyFunction, true) : companyFunctions.add(item as entities.CompanyFunction);
                default: return assertNever(levelID, `Unknown tracking level ${levelID}.`);
            }
        },

        editAll: (levelID: TrackingLevel, items: entities.TrackingLevelItemBase[], sync = false): any => {
            switch (levelID) {
                case TrackingLevel.PRODUCT: return sync ? products.editAll(items, true) : products.editAll(items);
                case TrackingLevel.GEO_AREA: return sync ? geoAreas.editAll(items, true) : geoAreas.editAll(items);
                case TrackingLevel.CUSTOMER: return sync ? customers.editAll(items, true) : customers.editAll(items);
                case TrackingLevel.TRACKING_LEVEL_1: return sync ? trackingLevel1Items.editAll(items, true) : trackingLevel1Items.editAll(items);
                case TrackingLevel.TRACKING_LEVEL_2: return sync ? trackingLevel2Items.editAll(items, true) : trackingLevel2Items.editAll(items);
                case TrackingLevel.TRACKING_LEVEL_3: return sync ? trackingLevel3Items.editAll(items, true) : trackingLevel3Items.editAll(items);
                case TrackingLevel.TRACKING_LEVEL_4: return sync ? trackingLevel4Items.editAll(items, true) : trackingLevel4Items.editAll(items);
                    // case TrackingLevel.COMPANY_LEGAL_ENTITY: return reloadAfterSync ? companyLegalEntities.editAll(items as entities.CompanyLegalEntity[], true, true) : sync ? companyLegalEntities.editAll(items as entities.CompanyLegalEntity[], true) : companyLegalEntities.editAll(items as entities.CompanyLegalEntity[]);
                    // case TrackingLevel.COMPANY_FUNCTION: return reloadAfterSync ? companyFunctions.editAll(items as entities.CompanyFunction[], true, true) : sync ? companyFunctions.editAll(items as entities.CompanyFunction[], true) : companyFunctions.editAll(items as entities.CompanyFunction[]);
                default: return items; // assertNever(levelID, `Unknown tracking level ${levelID}.`);
            }
        },

        edit: (levelID: TrackingLevel, item: entities.TrackingLevelItemBase, sync = false): any => {
            switch (levelID) {
                case TrackingLevel.PRODUCT: return sync ? products.edit(item, true) : products.edit(item);
                case TrackingLevel.GEO_AREA: return sync ? geoAreas.edit(item, true) : geoAreas.edit(item);
                case TrackingLevel.CUSTOMER: return sync ? customers.edit(item, true) : customers.edit(item);
                case TrackingLevel.TRACKING_LEVEL_1: return sync ? trackingLevel1Items.edit(item, true) : trackingLevel1Items.edit(item);
                case TrackingLevel.TRACKING_LEVEL_2: return sync ? trackingLevel2Items.edit(item, true) : trackingLevel2Items.edit(item);
                case TrackingLevel.TRACKING_LEVEL_3: return sync ? trackingLevel3Items.edit(item, true) : trackingLevel3Items.edit(item);
                case TrackingLevel.TRACKING_LEVEL_4: return sync ? trackingLevel4Items.edit(item, true) : trackingLevel4Items.edit(item);
                case TrackingLevel.COMPANY_LEGAL_ENTITY: return sync ? companyLegalEntities.edit(item as entities.CompanyLegalEntity, true) : companyLegalEntities.edit(item as entities.CompanyLegalEntity);
                case TrackingLevel.COMPANY_FUNCTION: return sync ? companyFunctions.edit(item as entities.CompanyFunction, true) : companyFunctions.edit(item as entities.CompanyFunction);
                default: return assertNever(levelID, `Unknown tracking level ${levelID}.`);
            }
        },

        delete: (levelID, item) => {
            switch (levelID) {
                case TrackingLevel.PRODUCT: return products.delete(item);
                case TrackingLevel.GEO_AREA: return geoAreas.delete(item);
                case TrackingLevel.CUSTOMER: return customers.delete(item);
                case TrackingLevel.TRACKING_LEVEL_1: return trackingLevel1Items.delete(item);
                case TrackingLevel.TRACKING_LEVEL_2: return trackingLevel2Items.delete(item);
                case TrackingLevel.TRACKING_LEVEL_3: return trackingLevel3Items.delete(item);
                case TrackingLevel.TRACKING_LEVEL_4: return trackingLevel4Items.delete(item);
                case TrackingLevel.COMPANY_LEGAL_ENTITY: return companyLegalEntities.delete(item as entities.CompanyLegalEntity);
                case TrackingLevel.COMPANY_FUNCTION: return companyFunctions.delete(item as entities.CompanyFunction);
                default: return assertNever(levelID, `Unknown tracking level ${levelID}.`);
            }
        },

        findOrCreateDefault: (levelID): any => {
            switch (levelID) {
                case TrackingLevel.PRODUCT: return products.findOrCreateDefault();
                case TrackingLevel.GEO_AREA: return geoAreas.findOrCreateDefault();
                case TrackingLevel.CUSTOMER: return customers.findOrCreateDefault();
                case TrackingLevel.TRACKING_LEVEL_1: return trackingLevel1Items.findOrCreateDefault();
                case TrackingLevel.TRACKING_LEVEL_2: return trackingLevel2Items.findOrCreateDefault();
                case TrackingLevel.TRACKING_LEVEL_3: return trackingLevel3Items.findOrCreateDefault();
                case TrackingLevel.TRACKING_LEVEL_4: return trackingLevel4Items.findOrCreateDefault();
                case TrackingLevel.COMPANY_LEGAL_ENTITY: return companyLegalEntities.findOrCreateDefault();
                case TrackingLevel.COMPANY_FUNCTION: return companyFunctions.findOrCreateDefault();
                default: return assertNever(levelID, `Unknown tracking level ${levelID}.`);
            }
        }
    },


    searchAllERPSyncProductsSlices = (templates: entities.ERPSyncItemPaginationSlice<entities.ERPSyncProductReport>[], options: { maxCount?: number; sortMode?: number; indicatorIDs?: number[]; indicatorStartDate?: Date; indicatorEndDate?: Date; } = {}) =>
        networkAction(
            'SEARCH_ALL_ERP_SYNC_PRODUCTS_SLICES',
            { templates },
            getAPIMethod<entities.ERPSyncItemPaginationSlice<entities.ERPSyncProductReport>[]>('ERPSyncProductApi', 'eRPSyncProductSearchAllSlicesPut'),
            templates,
            options
        ),

    searchERPSyncProductsSlice = (template: entities.ERPSyncItemPaginationSlice<entities.ERPSyncProductReport>, options: { startID?: number; maxCount?: number; sortMode?: number; indicatorIDs?: number[]; indicatorStartDate?: Date; indicatorEndDate?: Date; } = {}) =>
        networkAction(
            'SEARCH_ERP_SYNC_PRODUCTS_SLICE',
            { template },
            getAPIMethod<entities.ERPSyncItemPaginationSlice<entities.ERPSyncProductReport>>('ERPSyncProductApi', 'eRPSyncProductSearchSlicePut'),
            template,
            options
        ),

    editAllERPSyncProducts = (erpSyncProducts: entities.ERPSyncProductReport[]) =>
        networkAction('EDIT_ALL_ERP_SYNC_PRODUCTS', { erpSyncProducts }, getAPIMethod('ERPSyncProductApi', 'eRPSyncProductEditAllPut'), erpSyncProducts),

    voidAllERPSyncProductsSlices = (templates: entities.ERPSyncItemPaginationSlice<entities.ERPSyncProductReport>[]) => action('VOID_ALL_ERP_SYNC_PRODUCTS_SLICES', { templates }),

    searchAllERPSyncCustomersSlices = (templates: entities.ERPSyncItemPaginationSlice<entities.ERPSyncCustomerReport>[], options: { maxCount?: number; sortMode?: number; indicatorIDs?: number[]; indicatorStartDate?: Date; indicatorEndDate?: Date; } = {}) =>
        networkAction(
            'SEARCH_ALL_ERP_SYNC_CUSTOMERS_SLICES',
            { templates },
            getAPIMethod<entities.ERPSyncItemPaginationSlice<entities.ERPSyncCustomerReport>[]>('ERPSyncCustomerApi', 'eRPSyncCustomerSearchAllSlicesPut'),
            templates,
            options
        ),

    searchERPSyncCustomersSlice = (template: entities.ERPSyncItemPaginationSlice<entities.ERPSyncCustomerReport>, options: { startID?: number; maxCount?: number; sortMode?: number; indicatorIDs?: number[]; indicatorStartDate?: Date; indicatorEndDate?: Date; } = {}) =>
        networkAction(
            'SEARCH_ERP_SYNC_CUSTOMERS_SLICE',
            { template },
            getAPIMethod<entities.ERPSyncItemPaginationSlice<entities.ERPSyncCustomerReport>>('ERPSyncCustomerApi', 'eRPSyncCustomerSearchSlicePut'),
            template,
            options
        ),

    editAllERPSyncCustomers = (erpSyncCustomers: entities.ERPSyncCustomerReport[]) =>
        networkAction('EDIT_ALL_ERP_SYNC_CUSTOMERS', { erpSyncCustomers }, getAPIMethod('ERPSyncCustomerApi', 'eRPSyncCustomerEditAllPut'), erpSyncCustomers),

    voidAllERPSyncCustomersSlices = (templates: entities.ERPSyncItemPaginationSlice<entities.ERPSyncCustomerReport>[]) => action('VOID_ALL_ERP_SYNC_CUSTOMERS_SLICES', { templates }),

    voidCorporateStructure = () => action('VOID_CORPORATE_STRUCTURE');


export type CorporateStructureAction = ExtractAction<
| typeof trackingLevels
| typeof loadAllCompanyLegalEntityTypes
| typeof loadAllCorporateStructureSortModes
| typeof products
| typeof geoAreas
| typeof customers
| typeof trackingLevel1Items
| typeof trackingLevel2Items
| typeof trackingLevel3Items
| typeof trackingLevel4Items
| typeof companyLegalEntities
| typeof companyFunctions
| typeof setTeamCustomRoadmapRange
| typeof setCompanyFunctionCustomJourneyRange
| typeof setUserCustomRoadmapRange
| typeof companyVirtualTeams
| typeof setCompanyVirtualTeamCustomJourneyRange
| typeof companyVirtualTeamMembers
| typeof searchAllERPSyncProductsSlices
| typeof searchERPSyncProductsSlice
| typeof editAllERPSyncProducts
| typeof voidAllERPSyncProductsSlices
| typeof searchAllERPSyncCustomersSlices
| typeof searchERPSyncCustomersSlice
| typeof editAllERPSyncCustomers
| typeof voidAllERPSyncCustomersSlices
| typeof voidCorporateStructure
>;
